import { render, staticRenderFns } from "./carmonthcutrule.vue?vue&type=template&id=6cfd96d2&scoped=true&"
import script from "./carmonthcutrule.vue?vue&type=script&lang=js&"
export * from "./carmonthcutrule.vue?vue&type=script&lang=js&"
import style0 from "./carmonthcutrule.vue?vue&type=style&index=0&id=6cfd96d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfd96d2",
  null
  
)

export default component.exports